import React, { useContext, useState } from "react";
import AuthContext from "../../services/firebase/auth-context/provider";
import { subscribeToNewsletter } from "../../services/firebase/newsletter";
import MakroAlert, { MakroAlertType } from "./alert";
import LoadingSpinner from "./loading-spinner";
import { useAnalytics } from "../../hooks/use-ga";
var SubscriptionStatusType;
(function (SubscriptionStatusType) {
    SubscriptionStatusType[SubscriptionStatusType["NONE"] = 0] = "NONE";
    SubscriptionStatusType[SubscriptionStatusType["LOADING"] = 1] = "LOADING";
    SubscriptionStatusType[SubscriptionStatusType["SUCCESS"] = 2] = "SUCCESS";
    SubscriptionStatusType[SubscriptionStatusType["ERROR"] = 3] = "ERROR";
})(SubscriptionStatusType || (SubscriptionStatusType = {}));
var NewsletterSubscriptionForm = function NewsletterSubscriptionForm() {
    var _useState = useState(SubscriptionStatusType.NONE), status = _useState[0], setStatus = _useState[1];
    var _useState2 = useState(), message = _useState2[0], setMessage = _useState2[1];
    var user = useContext(AuthContext)[0].user;
    var UNKNOWN_FAILURE = "Es ist ein unerwarteter Fehler aufgetreten.";
    var onSubscribe = function onSubscribe(email) {
        setStatus(SubscriptionStatusType.LOADING);
        subscribeToNewsletter(email).then(function (result) {
            var _result$data, _result$data2;
            setStatus((_result$data = result.data) !== null && _result$data !== void 0 && _result$data.success ? SubscriptionStatusType.SUCCESS : SubscriptionStatusType.ERROR);
            setMessage((_result$data2 = result.data) !== null && _result$data2 !== void 0 && _result$data2.message ? result.data.message : UNKNOWN_FAILURE);
        }).catch(function (err) {
            setStatus(SubscriptionStatusType.ERROR);
            console.error("Error during newsletter subscription for " + email, err);
        });
    };
    var _useAnalytics = useAnalytics(), trackSubNewsletter = _useAnalytics.trackSubNewsletter;
    var onSubmit = function onSubmit(event) {
        event.preventDefault(); // @ts-ignore
        onSubscribe(document.getElementById("newsletter-email").value);
        trackSubNewsletter("newsletterButton");
    };
    switch (status) {
        case SubscriptionStatusType.LOADING:
            return /*#__PURE__*/ React.createElement(LoadingSpinner, null);
        case SubscriptionStatusType.SUCCESS:
            return /*#__PURE__*/ React.createElement(MakroAlert, {
                type: MakroAlertType.SUCCESS,
                text: "Sie wurden erfolgreich zum Newsletter angemeldet. Sie erhalten in K\xFCrze eine E-Mail mit einem Best\xE4tigungslink."
            });
        case SubscriptionStatusType.ERROR:
            return /*#__PURE__*/ React.createElement(MakroAlert, {
                type: MakroAlertType.DANGER,
                text: message ? message : UNKNOWN_FAILURE
            });
    }
    return /*#__PURE__*/ React.createElement("form", {
        onSubmit: onSubmit,
        className: "flex flex-wrap"
    }, /*#__PURE__*/ React.createElement("input", {
        type: "email",
        placeholder: "Ihre E-Mail Adresse",
        id: "newsletter-email",
        className: "flex-1 py-2",
        defaultValue: user && user.email ? user.email : "",
        required: true
    }), /*#__PURE__*/ React.createElement("input", {
        type: "submit",
        value: "Zum Newsletter anmelden",
        className: "w-full sm:w-auto px-4 py-1 cursor-pointer bg-gray-400 hover:text-white hover:bg-makroOrange"
    }));
};
export default NewsletterSubscriptionForm;
